export class Zaglavlje{

    constructor() {}

    Sediste: string = null;
    NazivSedista: string = null;
    DatumIzvoda: string = null;
    TipSloga: string = null;

    Deserialize(input:any){
        this.Sediste=input.Sediste._text;
        this.NazivSedista = input.NazivSedista._text;
        this.DatumIzvoda = input.DatumIzvoda._text;
        this.TipSloga = input.TipSloga._text;
        return this;
    }

}